angular.module('AsyncPanel',[
    'ngLodash',
    'ResourceGenerator',
    'ActionManager',
    'sod-logger'
]);
